export const tableHeader = (t) => [
  { id: "scfId", type: "text", label: t('gap-analysis:table.controlCode'), sortable: true },
  { id: "scfControl", type: "text", label: t('gap-analysis:table.control'), sortable: true },
  { id: "scfDomain", type: "dropdown", label: t('gap-analysis:table.domain'), sortable: true },
  { id: "controlWeighting", type: "number", label: t('gap-analysis:table.controlWeight'), sortable: true },
  { id: "vinculado", type: "boolean", label: t('gap-analysis:table.link'), sortable: true },
  { id: "actions-add", type: "actions-add", label: "" },
];
